import { useLayoutEffect } from 'react';
import { usePageTitleContext } from './PageTitleContext';
export function usePageTitle(pageTitle) {
    const { appBaseTitle } = usePageTitleContext();
    useLayoutEffect(() => {
        if (!pageTitle) {
            window.document.title = appBaseTitle;
            return;
        }
        const pageTitleFormatted = Array.isArray(pageTitle) ? pageTitle.join(' > ') : pageTitle;
        window.document.title = appBaseTitle + ' - ' + pageTitleFormatted;
        return () => {
            window.document.title = appBaseTitle;
        };
    }, []);
}
//# sourceMappingURL=usePageTitle.js.map